import React from "react";
import styles from "./Work.module.scss";
import Image from "next/image";
function Works() {
  return (
    <section className={styles.howItWorks} id="features">
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
        <h2 className={styles.iconContainer}>
  How{" "}
  <span className={styles.relative}>
    Agentic Commerce
    <span className={styles.iconWrapper}>
      <Image
        src="/agent-icons/sparkle.svg"
        alt="Sparkle Icon"
        width={12}
        height={12}
      />
    </span>
  </span>{" "}
  Works
</h2>

          <p>
            Our AI-powered system follows a sophisticated process to deliver
            personalized shopping experiences.
          </p>
        </div>
        <div className={styles.featuresGrid}>
          <div className={styles.featureCard}>
            <div className={styles.stepNumber}>1</div>
            <div className={styles.featureIcon}>
              {/* <Target size={20} /> */}
              <Image
                src="/agent-icons/target.svg"
                alt="Target"
                width={20}
                height={20}
                className={styles.whiteIcon}
              />
            </div>
            <h3>Customer Intent Analysis</h3>
            <p>
              AI analyzes customer behavior, preferences, and context to
              understand what they&quot;re looking for.
            </p>
            {/* <a href="#" className={styles.featureLink}>
              Learn more
              <Image
                src="/agent-icons/arrow.svg"
                alt="arrow"
                width={12}
                height={12}
                className={styles.whiteIcon}
              />
            </a> */}
          </div>

          <div className={styles.featureCard}>
            <div className={styles.stepNumber}>2</div>
            <div className={styles.featureIcon}>
              <Image
                src="/agent-icons/brain.svg"
                alt="Intelligent Recommendation"
                width={20}
                height={20}
                className={styles.whiteIcon}
              />
            </div>
            <h3>Intelligent Recommendation</h3>
            <p>
              Advanced algorithms generate personalized product suggestions in
              real-time.
            </p>
            {/* <a href="#" className={styles.featureLink}>
              Learn more
              <Image
                src="/agent-icons/arrow.svg"
                alt="arrow"
                width={12}
                height={12}
                className={styles.whiteIcon}
              />
            </a> */}
          </div>

          <div className={styles.featureCard}>
            <div className={styles.stepNumber}>3</div>
            <div className={styles.featureIcon}>
              {/* <MessageSquare size={20} /> */}
              <Image
                src="/agent-icons/message.svg"
                alt="AI Agents"
                width={24}
                height={24}
                className={styles.whiteIcon}
              />
              
            </div>
            <h3>Conversational Assistance</h3>
            <p>
              Natural language processing enables seamless customer
              interactions.
            </p>
            {/* <a href="#" className={styles.featureLink}>
              Learn more
              <Image
                src="/agent-icons/arrow.svg"
                alt="arrow"
                width={12}
                height={12}
                className={styles.whiteIcon}
              />
            </a> */}
          </div>

          <div className={styles.featureCard}>
            <div className={styles.stepNumber}>4</div>
            <div className={styles.featureIcon}>
              {/* <Settings size={20} /> */}
              <Image
                src="/agent-icons/setting.svg"
                alt="Autonomous Actions"
                width={20}
                height={20}
                className={styles.whiteIcon}
              />
            </div>
            <h3>Autonomous Actions</h3>
            <p>
              AI agents execute tasks like inventory updates, pricing, and
              customer service autonomously.
            </p>
            {/* <a href="#" className={styles.featureLink}>
              Learn more
              <Image
                src="/agent-icons/arrow.svg"
                alt="arrow"
                width={12}
                height={12}
                className={styles.whiteIcon}
              />
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Works;
